import axios from 'axios';
import debounce from 'lodash/debounce';
import dayjs from 'dayjs';
import i18n from '@/i18n';

const defaultFilters = {
  clientCompanyId: null,
  programId: null,
  from: dayjs().startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
  to: dayjs().endOf('month').format('YYYY-MM-DDTHH:mm:ss'),
  ticketCategory: 'INSURED',
  agentIds: []
};
const state = {
  dashboardMetrics: null,
  overviewMetrics: null,
  dashboardFilters: defaultFilters,
};

const getters = {
  dashboardMetrics: (state) => state.dashboardMetrics,
  overviewMetrics: (state) => state.overviewMetrics,
  dashboardFilters: (state) => state.dashboardFilters,
};

const mutations = {
  SET_DASHBOARD_METRICS(state, metrics) {
    state.dashboardMetrics = metrics;
  },
  SET_OVERVIEW_METRICS(state, metrics) {
    state.overviewMetrics = metrics;
  },
  SET_DASHBOARD_FILTERS(state, dashboardFilters) {
    state.dashboardFilters = { ...state.dashboardFilters, ...dashboardFilters };
  },
  CLEAR_DASHBOARD_METRICS(state) {
    state.dashboardMetrics = null;
  },
  CLEAR_OVERVIEW_METRICS(state) {
    state.overviewMetrics = null;
  },
  CLEAR_DASHBOARD_FILTERS(state, dashboardFilters) {
    state.dashboardFilters = { ...defaultFilters, ticketCategory: state.dashboardFilters.ticketCategory };
  },
};

const actions = {
  async fetchDashboardMetrics({
    commit,
    state,
  }) {
    try {
      const response = await axios.post(
        `/insurance/metric${state.dashboardFilters.ticketCategory === 'LEAD' ? '/lead' : ''}/detail`,
        state.dashboardFilters,
        {
          headers: {
            'X-Locale': i18n.locale,
          }
        }
      );
      commit('SET_DASHBOARD_METRICS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_DASHBOARD_METRICS', {
        renewed: {
          percentDiff: -13,
          policiesCount: 614,
          value: 100
        },
        expected: {
          percentDiff: 13,
          policiesCount: 614,
          value: 100
        },
        overdue: {
          percentDiff: -13,
          policiesCount: 614,
          value: 100
        },
        missing_validity: {
          percentDiff: -13,
          policiesCount: 614,
          value: 100
        },
        not_renewed: {
          percentDiff: -13,
          policiesCount: 614,
          value: 100
        },
      });
      console.error('Error fetching dashboard:', error);
    }
  },
  async fetchOverviewMetrics({
    commit,
    state,
  }) {
    try {
      const {
        from,
        to,
        // clientCompanyId,
        // programId,
      } = state.dashboardFilters;
      const payload = {
        from,
        to,
        // clientCompanyId,
        // programId,
        ticketCategory: 'INSURED',
      };
      const response = await axios.post(
        '/insurance/metric/detail',
        payload,
        {
          headers: {
            'X-Locale': i18n.locale,
          }
        }
      );
      commit('SET_OVERVIEW_METRICS', response.data);
      return response.data;
    } catch (error) {
      // keep previous overview metrics on error
      console.error('Error fetching overview metrics:', error);
    }
  },
  clearDashboardMetrics: ({ commit }) => {
    commit('CLEAR_DASHBOARD_METRICS');
  },
  clearDashboardFilters: ({ commit }) => {
    commit('CLEAR_DASHBOARD_FILTERS');
  },
  updateDashboardFilters: debounce(({
    commit,
    dispatch,
  }, dashboardFilters, fetchOverviewMetrics = false) => {
    commit('SET_DASHBOARD_FILTERS', dashboardFilters);
    dispatch('fetchDashboardMetrics');
    dispatch('fetchOverviewMetrics');
  }, 0),
};

export default {
  state,
  getters,
  mutations,
  actions,
};
